import notificationConfigAdapter from '@/adapters/notificationConfigAdapter';
import axiosApiConfig from '@/axiosApiConfig';
import { PaginationResponse } from '@/hooks/usePaginationService';
import INotification from '@/interfaces/INotification';
import INotificationConfig, { INotificationConfigDto } from '@/interfaces/INotificationConfig';
import INotificationLog from '@/interfaces/INotificationLog';
import INotificationSummary from '@/interfaces/INotificationSummary';
import IParams from '@/interfaces/IParams';

export async function getNotificationsPaginated(
  skip: number, 
  limit: number, 
  params?: IParams,
): Promise<PaginationResponse<INotification>> {
  const result = await axiosApiConfig.get<PaginationResponse<INotification>>('/notifications', { 
    params: { 
      ...params,
      $skip: skip,
      $limit: limit,
    },
  });

  // console.log({ ...result.data });
  return {
    total: result.data.total,
    skip: result.data.skip,
    limit: result.data.limit,
    data: result.data.data,
  };
}

export const getNotificationConfigs = async (params?: IParams): Promise<INotificationConfig[]> => {
  const result = await axiosApiConfig.get<INotificationConfigDto[]>('/notification_configs', { params: { ...params } });

  return notificationConfigAdapter(result.data);
};

export const getNotificationSummaries = async (params?: IParams): Promise<INotificationSummary[]> => {
  const result = await axiosApiConfig.get<INotificationSummary[]>('/notification_summaries', { params: { ...params } });

  return result.data;
};

export const getNotificationLogs = async (params?: IParams): Promise<INotificationLog[]> => {
  const result = await axiosApiConfig.get<INotificationLog[]>('/notification_logs', { params: { ...params } });

  return result.data;
};

export const addNotificationTokens = async (qty: number, type: INotificationLog['type']): Promise<void> => {
  await axiosApiConfig.post<INotificationLog[]>('/add_notification_tokens', { 
    qty, 
    type,
  });
};

export const updateNotificationConfig = async (
  notificationConfigId: number, 
  defaultValue: boolean,
): Promise<INotificationLog[]> => {
  const result = await axiosApiConfig.patch<INotificationLog[]>(`/notification_configs/${notificationConfigId}`, { defaultValue });

  return result.data;
};

export async function getNotificationLogPaginated(
  skip: number, 
  limit: number, 
  params?: IParams,
): Promise<PaginationResponse<INotificationLog>> {
  const result = await axiosApiConfig.get<PaginationResponse<INotificationLog>>('/notification_logs', { 
    params: { 
      ...params,
      $skip: skip,
      $limit: limit,
    },
  });

  // console.log({ ...result.data });
  return result.data;
}

export default { getNotificationsPaginated };
